import WebsiteConfig from "../model/WebsiteConfig";

export function getConfig(): WebsiteConfig {
    return window.WebConf || {};
}
